<template>
  <v-container ma-0 pa-0>
    <div class="filter-wrapper scrollable">
      <h3 class="filter-title">{{ $t('filters.title') }}
        <v-btn icon
               :title="$t('filters.clear_all')"
               :aria-label="$t('filters.clear_all')"
               @click="clearFilters"
               :disabled="selectedDuration === 0 && selectedEnrolment.length === 0"
               class="filter-button">
          <v-tooltip bottom>
            <v-icon medium slot="activator">close</v-icon>
            <span v-html="$t('filters.clear_all')"></span>
          </v-tooltip>
        </v-btn>
      </h3>

      <h4 class="mt-1 mb-2">{{$t('student.filters.headers.enrolment_status')}}</h4>
      <EnrolmentStatusSelection :enrolmentStatus="enrolmentStatus" />

      <h4 class="mt-4 mb-2">{{$t('data_purge.duration_label')}}</h4>
      <v-radio-group v-model="selectedDuration" class="pt-0">
        <v-radio v-for="item in duration"
                 :key="item.id"
                 :label="getDurationLabel(item)"
                 :value="item.id"
                 color="primary" />
      </v-radio-group>
    </div>
    <v-btn color="primary"
           class="apply-button ma-0"
           :disabled="selectedDuration === 0 || selectedEnrolment.length === 0 || loading"
           @click="applyFilters">
      {{$t('apply')}}
    </v-btn>
  </v-container>
</template>

<script>
  import { mapActions, mapMutations, mapState } from 'vuex'
  import {
    GET_DATA_PURGE_DURATION,
    GET_DATA_PURGE_ENROLMENT_STATUS,
    GET_DATA_PURGE_STUDENTS
  } from '../../store/action-types'
  import {
    RESET_DATA_PURGE_STUDENTS,
    RESET_PURGE_FILTER_AND_SEARCH,
    SET_DATA_PURGE_PAGE_NUMBER,
    SET_SELECTED_DURATION,
    SET_SELECTED_ENROLMENT_STATUS
  } from '../../store/mutation-types'
  import FilterComponent from '../filter/FilterComponent'
  import FilterList from '../filter/FilterList'
  import RightDrawer from '../../mixins/RightDrawer'
  import EnrolmentStatusSelection from './EnrolmentStatusSelection'

  export default {
    name: 'DataPurgeFilter',
    mixins: [RightDrawer],
    components: {
      EnrolmentStatusSelection,
      FilterComponent,
      FilterList
    },
    data () {
      return {
      }
    },
    computed: {
      ...mapState({
        loading: state => state.dataPurge.loading,
        enrolmentStatus: state => state.dataPurge.enrolmentStatus,
        duration: state => state.dataPurge.duration,
        selectedEnrolment: state => state.dataPurge.selectedEnrolment
      }),
      selectedDuration: {
        get () {
          return this.$store.state.dataPurge.selectedDuration
        },
        set (value) {
          this.$store.commit(SET_SELECTED_DURATION, value)
        }
      }
    },
    methods: {
      ...mapMutations({
        setSelectedEnrolmentStatus: SET_SELECTED_ENROLMENT_STATUS,
        setSelectedDuration: SET_SELECTED_DURATION,
        setPageNumber: SET_DATA_PURGE_PAGE_NUMBER,
        resetStudents: RESET_DATA_PURGE_STUDENTS,
        resetFilters: RESET_PURGE_FILTER_AND_SEARCH
      }),
      ...mapActions({
        getStudents: GET_DATA_PURGE_STUDENTS,
        getEnrolmentStatus: GET_DATA_PURGE_ENROLMENT_STATUS,
        getDuration: GET_DATA_PURGE_DURATION
      }),
      getDurationLabel (item) {
        return item.duration + ' ' + item.durationType
      },
      applyFilters () {
        this.setPageNumber(0)
        this.getStudents()
        this.setDrawerState(false)
      },
      clearFilters () {
        this.resetStudents()
        this.resetFilters()
      }
    },
    created () {
      this.getEnrolmentStatus()
      this.getDuration()
    }
  }
</script>

<style scoped>
  .scrollable {
    max-height: calc(100vh - 160px);
    overflow-y: auto;
  }

  .filter-title {
    position: relative;
    margin: 20px 0;
  }

  .filter-button {
    position: absolute;
    top: -6px;
    right: 0;
    margin: 0;
  }

  .apply-button {
    width: 115px;
  }

  @media (max-width: 600px) {
    .scrollable {
      max-height: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/data-purge/DataPurgeFilter.vue